import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';

// project imports
import Customization from '../Customization';

// ==============================|| MINIMAL LAYOUT ||============================== //

// MainLayout renders CssBaseline but this one didn't, so the auth screens missed the
// theme's body background, scrollbar, selection and caret styling entirely — which is
// why index.html had to hard-code a black body to stop a white flash.
const MinimalLayout = () => (
  <>
    <CssBaseline />
    <Outlet />
    {/* <Customization /> */}
  </>
);

export default MinimalLayout;
